<template>
	<button :class="customClasses" class="fill-button">
		<span class="content"><slot></slot></span>
		<span class="icon" v-if="hasIcon" v-html="indicat"></span>
	</button>
</template>

<script>
import { arrow } from '@/components/../icons'

export default {
	name: 'button-vue',
	props: {
		type: String,
		arrowLink: {
			type: Boolean,
			default: false,
		},
		hasIcon: {
			type: Boolean,
			default: true,
		},
		bold: {
			type: Boolean,
			default: false,
		},
		outlined: {
			type: Boolean,
			default: true,
		},
		link: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
		uppercase: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		customClasses() {
			let custom = []
			if (this.type) custom.push(this.type)
			if (this.bold) custom.push('bold')
			if (this.arrowLink) custom.push('arrow-link')
			if (!this.arrowLink) {
				if (this.outlined) custom.push('outlined')
			}
			if (this.uppercase) custom.push('uppercase')
			if (this.small) custom.push('small')
			if (this.link) custom.push('link')
			if (this.hasIcon) {
				custom.push('has-icon')
			}
			return custom.splice(' ')
		},
		indicat() {
			return arrow('var(--alwaysDark)')
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
/* Stroke animation. Use ems to scale :) */
.fill-button {
	border: none;
	-webkit-appearance: none;
	cursor: pointer;
	padding: 12px 15px;
	background: var(--alwaysDark);
	color: $light;
	//box-shadow: inset 0px 0px 0 2px var(--alwaysDark);
	transition: 0.2s ease-in-out;
	@include fluid-type($smallResText, $wideResText, 14px, 20px);
	box-shadow: inset 0px 0px 0 2px var(--alwaysDark);

	&.arrow-link,
	&.arrow-link a {
		padding-left: 0 !important;
		background-color: transparent !important;
		box-shadow: none !important;
		color: var(--dark);
		svg {
			path {
				fill: var(--dark) !important;
			}
		}
	}
	&.small {
		@include fluid-type($smallResText, $wideResText, 12px, 16px);
	}
	&.uppercase {
		text-transform: uppercase;
	}
	&.outlined {
		box-shadow: inset 0px 0px 0 2px $light;
	}
	svg {
		path {
			fill: $light;
		}
	}
	&:hover {
		background-color: $light;
		color: var(--alwaysDark);
		svg {
			path {
				fill: var(--alwaysDark);
			}
		}
	}
	&.download {
		.icon {
			svg {
				transform: rotate(90deg);
			}
		}
	}
	&.external {
		.icon {
			svg {
				transform: rotate(-45deg);
			}
		}
	}
	&.has-icon {
		position: relative;
		padding-right: 50px;
		&.link {
			padding-right: 0px;
			a {
				padding-right: 50px;
			}
		}
		.icon {
			top: 50%;
			right: 25px;
			position: absolute;
			transform: translateY(-50%);
		}
	}
	&.link {
		padding: 0;
		a {
			text-decoration: none;
			padding: 12px 15px;
			display: inline-block;
		}
	}
	@include mquery($tablet) {
		padding: 10px 13px;
		&.link {
			padding: 0;
			a {
				padding: 8px 12px;
			}
		}
	}
	&.white {
		background: $light;
		color: var(--alwaysDark);
		box-shadow: inset 0px 0px 0 2px $light;
		&.outlined {
			box-shadow: inset 0px 0px 0 2px var(--alwaysDark);
		}
		svg {
			path {
				fill: var(--alwaysDark);
			}
		}
		&:hover {
			background-color: var(--alwaysDark);
			color: $light;
			svg {
				path {
					fill: $light;
				}
			}
		}
	}
}
</style>
